import { addHook } from '@viveaesthetics/elemy-shared-core'

import { useRouter } from '@/hooks/useRouter'

function paramToArray(param?: string | string[]) {
  if (!param) return []
  return Array.isArray(param) ? param : [param]
}

function paramToNonArray(param?: string | string[]) {
  if (!param) return ''
  return Array.isArray(param) ? param[0] : param
}

export interface UseParamsOptions<
  Params extends Record<string, string | string[]>
> {
  asArray: Array<keyof Params>
}

/**
 * The function returns url parameters.
 * By default, each single param is converted to string.
 * To get a param as an array need to pass asArray option with set of params' names.
 */
export const useParams = addHook({
  useParams: <Params extends Record<string, string | string[]>>(
    options?: UseParamsOptions<Params>
  ) => {
    const { query } = useRouter()

    return Object.entries(query).reduce((preparedParams, [key, value]) => {
      return {
        ...preparedParams,
        [key]: options?.asArray.includes(key)
          ? paramToArray(value)
          : paramToNonArray(value)
      }
    }, {}) as Params
  }
})
